import { AsyncPipe } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconButtonComponent } from 'src/app/shared/icon-button/icon-button.component';
import { MenuService } from 'src/app/shared/services/menu/menu.service';

@Component({
  selector: 'app-menu-header',
  imports: [RouterLink, AsyncPipe, IconButtonComponent],
  templateUrl: './menu-header.component.html',
  styleUrl: './menu-header.component.scss',
})
export class MenuHeaderComponent {
  @Input() public offcanvas: boolean = false;

  protected menuService = inject(MenuService);

  public toggleMenu(): void {
    this.menuService.toggleMenuCollapsed();
  }
}
